/**
 * Model Wizard API Client
 * API methods for form-based model registration
 */
import { adminAxios } from './api';

export interface WizardStepData {
  [key: string]: any;
}

export interface ModelScriptInfo {
  file_base: string;
  cpp_filename: string;
  r_filename: string;
  has_cpp_file: boolean;
  has_r_file: boolean;
  registration_status: 'complete' | 'partial' | 'missing' | string;
  issues: string[];
}

export interface WizardSaveRequest {
  model_id: string;
  step: number;
  draft: boolean;
  data: WizardStepData;
}

export interface WizardSaveResponse {
  model_id: string;
  message: string;
  draft: boolean;
  last_edited_step: number;
}

export interface WizardGetResponse {
  model_id: string;
  draft: boolean;
  last_edited_step: number;
  step1?: any;
  step2?: any;
  step3?: any;
  step4?: any;
  step5?: any;
  step6?: any;
  step7?: any;
}

export interface ModelDraftItem {
  model_id: string;
  first_author?: string;
  drug_name?: string;
  created_at?: string;
  updated_at?: string;
  last_edited_step: number;
}

export interface ModelDraftListResponse {
  drafts: ModelDraftItem[];
  total: number;
}

export interface ModelSubmitResponse {
  message: string;
  model_id: string;
  json_file_path?: string;
}

export interface ModelScriptUploadResponse {
  message: string;
  model_id: string;
  draft: boolean;
  last_edited_step?: number;
  script_info: ModelScriptInfo;
}

const modelWizardAPI = {
  /**
   * 保存向导步骤数据
   */
  saveWizardStep: (request: WizardSaveRequest) =>
    adminAxios.post<WizardSaveResponse>('/api/admin/models/wizard', request).then(r => r.data),

  /**
   * 获取模型向导数据
   */
  getWizardData: (modelId: string) =>
    adminAxios.get<WizardGetResponse>(`/api/admin/models/${encodeURIComponent(modelId)}/wizard`).then(r => r.data),

  /**
   * 提交完整模型
   */
  submitModel: (modelId: string) =>
    adminAxios.post<ModelSubmitResponse>(`/api/admin/models/${encodeURIComponent(modelId)}/submit`).then(r => r.data),

  /**
   * 获取草稿列表
   */
  listDrafts: () =>
    adminAxios.get<ModelDraftListResponse>('/api/admin/models/drafts').then(r => r.data),

  /**
   * 删除草稿
   */
  deleteDraft: (modelId: string) =>
    adminAxios.delete(`/api/admin/models/${encodeURIComponent(modelId)}/draft`).then(r => r.data),

  uploadDraft: (formData: FormData) =>
    adminAxios.post<ModelScriptUploadResponse>('/api/admin/models/upload', formData).then(r => r.data),

  updateModelScripts: (modelId: string, formData: FormData) =>
    adminAxios.post<ModelScriptUploadResponse>(`/api/admin/models/${encodeURIComponent(modelId)}/scripts`, formData).then(r => r.data),
};

export default modelWizardAPI;
